import { Icon } from '@chakra-ui/react';

export const CustomYellowUpArrowIcon = (props) => (
  <Icon viewBox="0 0 47 26" fill="none" {...props}>
    <path
      d="M32.1523 1H45.9985V14.7143"
      stroke="#FFCC00"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M45.9999 1L26.4423 20.3714C26.1187 20.6855 25.6838 20.8615 25.2307 20.8615C24.7777 20.8615 24.3427 20.6855 24.0192 20.3714L16.0577 12.4857C15.7341 12.1716 15.2992 11.9957 14.8461 11.9957C14.3931 11.9957 13.9581 12.1716 13.6346 12.4857L1 25"
      stroke="#FFCC00"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </Icon>
);
